/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';
import {TaskDTO} from '../model/taskDTO';
import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {FtpStoreConf} from '../model/ftpStoreConf';
import {PreviewCommandBody} from '../model/previewCommandBody';
import {ImportLineCountersDto} from '../model/importLineCountersDto';
import {ImportLineReplaceRequestDto} from '../model/importLineReplaceRequestDto';
import {ImportLineReplaceResultDto} from '../model/importLineReplaceResultDto';
import {ImportLineSearchCriteriaDto} from '../model/importLineSearchCriteriaDto';
import {ImportLineSearchResultsDto} from '../model/importLineSearchResultsDto';
import {ImportLineDto} from '../model/importLineDto';
import {ImportLinePageDto} from '../model/importLinePageDto';
import {ImportLinePatchDto} from '../model/importLinePatchDto';

@Injectable()
export class EngineEtlService {
    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * checkConfigFtp
     *
     * @param ftpStoreConf ftpStoreConf
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkConfigFtpUsingPOST(ftpStoreConf: FtpStoreConf, tenant: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public checkConfigFtpUsingPOST(ftpStoreConf: FtpStoreConf, tenant: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public checkConfigFtpUsingPOST(ftpStoreConf: FtpStoreConf, tenant: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public checkConfigFtpUsingPOST(ftpStoreConf: FtpStoreConf, tenant: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (ftpStoreConf === null || ftpStoreConf === undefined) {
            throw new Error('Required parameter ftpStoreConf was null or undefined when calling checkConfigFtpUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        if(tenant !=undefined){
            headers = headers.set('X-DataStoreID', String(tenant));
        }

        const url = `${this.basePath}/api/etl/${id}`

        return this.httpClient.post<{ [key: string]: string; }>(url,
            ftpStoreConf,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    /**
     * deleteThreadForTask
     *
     * @param idTask idTask
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteThreadForTaskUsingDELETE(idTask: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteThreadForTaskUsingDELETE(idTask: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteThreadForTaskUsingDELETE(idTask: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteThreadForTaskUsingDELETE(idTask: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling deleteThreadForTaskUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.delete<any>(`${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/thread`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idTask
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public importTask(xDataStoreID: string, idTask: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public importTask(xDataStoreID: string, idTask: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public importTask(xDataStoreID: string, idTask: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public importTask(xDataStoreID: string, idTask: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling importTask.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling importTask.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/import`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * play2
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param command command
     * @param date date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public play2UsingPOST(xDataStoreID: string, code: string, command?: string, date?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public play2UsingPOST(xDataStoreID: string, code: string, command?: string, date?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public play2UsingPOST(xDataStoreID: string, code: string, command?: string, date?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public play2UsingPOST(xDataStoreID: string, code: string, command?: string, date?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling play2UsingPOST.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling play2UsingPOST.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/etl/${encodeURIComponent(String(code))}/play-2`,
            command,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * playGet
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param command command
     * @param date date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playGetUsingGET(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public playGetUsingGET(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public playGetUsingGET(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public playGetUsingGET(xDataStoreID: string, code: string, command: string, date?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling playGetUsingGET.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling playGetUsingGET.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling playGetUsingGET.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/etl/${encodeURIComponent(String(code))}/play/${encodeURIComponent(String(command))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * play
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param command command
     * @param date date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playUsingPUT(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playUsingPUT(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playUsingPUT(xDataStoreID: string, code: string, command: string, date?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playUsingPUT(xDataStoreID: string, code: string, command: string, date?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling playUsingPUT.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling playUsingPUT.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling playUsingPUT.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/etl/${encodeURIComponent(String(code))}/play/${encodeURIComponent(String(command))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Page de lignes d'une tâche d'import
     * Pagination par keyset sur le numéro de ligne : passer en &#x60;after&#x60; le &#x60;nextAfter&#x60; de la page précédente, jamais un décalage.
     * @param xDataStoreID
     * @param idTask
     * @param status PENDING | ERROR | IMPORTED ; vide pour tous les états
     * @param errorKey Type d&#39;erreur à isoler (CAT:... ou FIELD:...), tel que renvoyé par /rows/counters
     * @param after Dernier numéro de ligne de la page précédente ; absent pour la première page
     * @param size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaskRows(xDataStoreID: string, idTask: string, status?: Array<string>, errorKey?: string, after?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<ImportLinePageDto>;
    public getTaskRows(xDataStoreID: string, idTask: string, status?: Array<string>, errorKey?: string, after?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportLinePageDto>>;
    public getTaskRows(xDataStoreID: string, idTask: string, status?: Array<string>, errorKey?: string, after?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportLinePageDto>>;
    public getTaskRows(xDataStoreID: string, idTask: string, status?: Array<string>, errorKey?: string, after?: number, size?: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTaskRows.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling getTaskRows.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (status) {
            status.forEach(element => {
                queryParameters = queryParameters.append('status', <any>element);
            });
        }
        if (errorKey !== undefined && errorKey !== null) {
            queryParameters = queryParameters.set('errorKey', <any>errorKey);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ImportLinePageDto>('get', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/rows`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Compteurs d'une tâche d'import
     * Nombre de lignes par état et ventilation par type d'erreur, sur TOUTE la tâche et non sur la page affichée.
     * @param xDataStoreID
     * @param idTask
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaskRowCounters(xDataStoreID: string, idTask: string, observe?: 'body', reportProgress?: boolean): Observable<ImportLineCountersDto>;
    public getTaskRowCounters(xDataStoreID: string, idTask: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportLineCountersDto>>;
    public getTaskRowCounters(xDataStoreID: string, idTask: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportLineCountersDto>>;
    public getTaskRowCounters(xDataStoreID: string, idTask: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getTaskRowCounters.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling getTaskRowCounters.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ImportLineCountersDto>('get', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/rows/counters`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Corriger une ligne d'une tâche d'import
     * Écrit les cellules corrigées, vide les erreurs de la ligne et la repasse en PENDING. Refusé si la ligne est déjà importée.
     * @param xDataStoreID
     * @param idTask
     * @param rowIndex Numéro de la ligne dans le fichier source
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    /**
     * Rechercher dans les lignes d&#39;une tâche d&#39;import
     * Renvoie une page d&#39;occurrences ET les compteurs exacts sur TOUTE la tâche. Les lignes déjà importées sont exclues.
     *
     * @param xDataStoreID
     * @param idTask
     * @param body critères de recherche
     * @param after dernier numéro de ligne de la page précédente d&#39;occurrences
     * @param size taille de page des occurrences (200 au maximum côté serveur)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchTaskRows(xDataStoreID: string, idTask: string, body: ImportLineSearchCriteriaDto, after?: number, size?: number, observe?: 'body', reportProgress?: boolean): Observable<ImportLineSearchResultsDto>;
    public searchTaskRows(xDataStoreID: string, idTask: string, body: ImportLineSearchCriteriaDto, after?: number, size?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportLineSearchResultsDto>>;
    public searchTaskRows(xDataStoreID: string, idTask: string, body: ImportLineSearchCriteriaDto, after?: number, size?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportLineSearchResultsDto>>;
    public searchTaskRows(xDataStoreID: string, idTask: string, body: ImportLineSearchCriteriaDto, after?: number, size?: number, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling searchTaskRows.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling searchTaskRows.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling searchTaskRows.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ImportLineSearchResultsDto>('post', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/rows/search`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remplacer en masse dans les lignes d&#39;une tâche d&#39;import
     * Deux modes. Avec &#x60;matches&#x60; : les occurrences cochées, avec la valeur éventuellement éditée. Sans &#x60;matches&#x60; : le serveur réapplique &#x60;criteria&#x60; à toutes les lignes correspondantes, par lots. Les lignes touchées repassent en PENDING avec leurs erreurs vidées.
     *
     * @param xDataStoreID
     * @param idTask
     * @param body critères et, éventuellement, occurrences retenues
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public replaceTaskRows(xDataStoreID: string, idTask: string, body: ImportLineReplaceRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ImportLineReplaceResultDto>;
    public replaceTaskRows(xDataStoreID: string, idTask: string, body: ImportLineReplaceRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportLineReplaceResultDto>>;
    public replaceTaskRows(xDataStoreID: string, idTask: string, body: ImportLineReplaceRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportLineReplaceResultDto>>;
    public replaceTaskRows(xDataStoreID: string, idTask: string, body: ImportLineReplaceRequestDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling replaceTaskRows.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling replaceTaskRows.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling replaceTaskRows.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ImportLineReplaceResultDto>('post', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/rows/replace`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public patchTaskRow(xDataStoreID: string, idTask: string, rowIndex: number, body: ImportLinePatchDto, observe?: 'body', reportProgress?: boolean): Observable<ImportLineDto>;
    public patchTaskRow(xDataStoreID: string, idTask: string, rowIndex: number, body: ImportLinePatchDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ImportLineDto>>;
    public patchTaskRow(xDataStoreID: string, idTask: string, rowIndex: number, body: ImportLinePatchDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ImportLineDto>>;
    public patchTaskRow(xDataStoreID: string, idTask: string, rowIndex: number, body: ImportLinePatchDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling patchTaskRow.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling patchTaskRow.');
        }

        if (rowIndex === null || rowIndex === undefined) {
            throw new Error('Required parameter rowIndex was null or undefined when calling patchTaskRow.');
        }

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling patchTaskRow.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ImportLineDto>('patch', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/rows/${encodeURIComponent(String(rowIndex))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * playWithFile
     *
     * @param xDataStoreID X-DataStoreID
     * @param code code
     * @param command command
     * @param async async
     * @param date date
     * @param file file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playWithFileUsingPOST(xDataStoreID: string, code: string, command: string, async?: boolean, date?: string, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playWithFileUsingPOST(xDataStoreID: string, code: string, command: string, async?: boolean, date?: string, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playWithFileUsingPOST(xDataStoreID: string, code: string, command: string, async?: boolean, date?: string, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playWithFileUsingPOST(xDataStoreID: string, code: string, command: string, async?: boolean, date?: string, file?: Blob, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling playWithFileUsingPOST.');
        }

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling playWithFileUsingPOST.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling playWithFileUsingPOST.');
        }




        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (async !== undefined && async !== null) {
            queryParameters = queryParameters.set('async', <any>async);
        }
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (file !== undefined) {
            formParams.append('file', <any>file);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/etl/${encodeURIComponent(String(code))}/play/${encodeURIComponent(String(command))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idTask
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateValidation(xDataStoreID: string, idTask: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateValidation(xDataStoreID: string, idTask: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateValidation(xDataStoreID: string, idTask: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateValidation(xDataStoreID: string, idTask: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateValidation.');
        }

        if (idTask === null || idTask === undefined) {
            throw new Error('Required parameter idTask was null or undefined when calling updateValidation.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put', `${this.basePath}/api/etl/task/${encodeURIComponent(String(idTask))}/validation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xDataStoreID
     * @param idEtl
     * @param command
     * @param body
     * @param date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     *
     *     @Deprecated
     */
    public previewWithFile(xDataStoreID: string, idEtl: string, command: string, body?: PreviewCommandBody, date?: string, observe?: 'body', reportProgress?: boolean): Observable<TaskDTO>;
    public previewWithFile(xDataStoreID: string, idEtl: string, command: string, body?: PreviewCommandBody, date?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskDTO>>;
    public previewWithFile(xDataStoreID: string, idEtl: string, command: string, body?: PreviewCommandBody, date?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskDTO>>;
    public previewWithFile(xDataStoreID: string, idEtl: string, command: string, body?: PreviewCommandBody, date?: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling previewWithFile.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling previewWithFile.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling previewWithFile.');
        }



        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TaskDTO>('post', `${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/preview/${encodeURIComponent(String(command))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Prévisualisation d&#39;un import
     * Lit le fichier et prépare les données pour un affichage. Les données sont stokées dans la base Mongodb. Les données peuvent être injecté en base.
     * @param xDataStoreID X-DataStoreID
     * @param command command
     * @param idEtl idEtl
     * @param date date
     * @param file file
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public previewWithFileUsingPOST(xDataStoreID: string, command: string, idEtl: string, date?: string, file?: Blob, observe?: 'body', reportProgress?: boolean): Observable<TaskDTO>;
    public previewWithFileUsingPOST(xDataStoreID: string, command: string, idEtl: string, date?: string, file?: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskDTO>>;
    public previewWithFileUsingPOST(xDataStoreID: string, command: string, idEtl: string, date?: string, file?: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskDTO>>;
    public previewWithFileUsingPOST(xDataStoreID: string, command: string, idEtl: string, date?: string, file?: Blob, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling previewWithFileUsingPOST.');
        }

        if (command === null || command === undefined) {
            throw new Error('Required parameter command was null or undefined when calling previewWithFileUsingPOST.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling previewWithFileUsingPOST.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (date !== undefined && date !== null) {
            queryParameters = queryParameters.set('date', <any>date);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (file !== undefined) {
            formParams.append('file', file as any);
        }

        return this.httpClient.post<TaskDTO>(`${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/preview/${encodeURIComponent(String(command))}`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lance le script
     *
     * @param xDataStoreID
     * @param idEtl
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runExportJob(xDataStoreID: string, idEtl: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runExportJob(xDataStoreID: string, idEtl: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runExportJob(xDataStoreID: string, idEtl: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runExportJob(xDataStoreID: string, idEtl: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runExportJob.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling runExportJob.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('post', `${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/script/export/run/job`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lance le script
     *
     * @param xDataStoreID
     * @param idEtl
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runScriptExport(xDataStoreID: string, idEtl: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runScriptExport(xDataStoreID: string, idEtl: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runScriptExport(xDataStoreID: string, idEtl: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runScriptExport(xDataStoreID: string, idEtl: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runScriptExport.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling runScriptExport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/script/export/run`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lance le script
     *
     * @param xDataStoreID
     * @param idEtl
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runScriptExportFile(xDataStoreID: string, idEtl: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runScriptExportFile(xDataStoreID: string, idEtl: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runScriptExportFile(xDataStoreID: string, idEtl: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runScriptExportFile(xDataStoreID: string, idEtl: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runScriptExportFile.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling runScriptExportFile.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv; charset=utf-8',
            'application/zip'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('post', `${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/script/export/run/file`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                responseType: 'blob' as 'json',
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lance le script
     *
     * @param xDataStoreID
     * @param idEtl
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runScriptImport(xDataStoreID: string, idEtl: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public runScriptImport(xDataStoreID: string, idEtl: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public runScriptImport(xDataStoreID: string, idEtl: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public runScriptImport(xDataStoreID: string, idEtl: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling runScriptImport.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling runScriptImport.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/api/etl/${encodeURIComponent(String(idEtl))}/script/import/run`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
